<template>
  <v-menu
    ref="birthdayMenu"
    v-model="birthdayMenu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="auto"
    content-class="elevation-1 mt-1"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="birthdayFormatted"
        :label="$t('views.signup.birthday.label')"
        readonly
        v-bind="attrs"
        hide-details
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker
      ref="datePicker"
      v-model="myValue"
      :max="birthdayMaxMinDates.max"
      :min="birthdayMaxMinDates.min"
      :locale="language"
      no-title
      class="mt-0 mb-0"
      @change="saveBirthdayMenu"
    ></v-date-picker>
  </v-menu>
</template>

<script>
import { DateTime } from 'luxon'
import { mapState } from 'vuex'

export default {
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      myValue: null,
      birthdayMenu: false,
    }
  },
  computed: {
    ...mapState(['language']),
    birthdayFormatted() {
      if (!this.myValue) return null

      const [year, month, day] = this.myValue.split('-')
      return `${day}/${month}/${year}`
    },
    birthdayMaxMinDates() {
      const max = DateTime.now().minus({ year: 10 }).endOf('year').toFormat('yyyy-MM-dd')
      const min = DateTime.now().minus({ year: 90 }).startOf('year').toFormat('yyyy-MM-dd')
      return {
        max,
        min,
      }
    },
  },
  watch: {
    value: {
      handler() {
        if (!this.value) return null
        this.myValue = DateTime.fromISO(this.value, { zone: 'utc' }).toFormat('yyyy-MM-dd')
      },
      immediate: true,
    },
    myValue() {
      this.$emit('input', DateTime.fromISO(this.myValue, { zone: 'utc' }).toISO())
    },
    birthdayMenu(val) {
      val && setTimeout(() => (this.$refs.datePicker.activePicker = 'YEAR'))
    },
  },
  methods: {
    saveBirthdayMenu(date) {
      this.$refs.birthdayMenu.save(date)
    },
  },
}
</script>

<style></style>
